import type { TGetCommunicationTemplates } from "@api";
import type { IVariable } from "@bbj-types/utils";
import type { Control, UseFormGetValues, UseFormSetValue } from "react-hook-form";
import { filterSmsTemplateType } from "../logic";
import { isSmsEligibleCandidate } from "../logics/eligible";
import { type IRecipientsForm, Recipients } from "../recipients";
import type { INotifyBySmsModalForm, TCandidateData } from "../types";
import { MenuTemplateSms } from "./menuTemplateSms";
import { SmsContent } from "./smsContent";

export interface ISmsModalFormProps<T extends TGetCommunicationTemplates> {
  candidates: readonly TCandidateData[];
  control: Control<INotifyBySmsModalForm, void>;
  setValue: UseFormSetValue<INotifyBySmsModalForm>;
  getValues: UseFormGetValues<INotifyBySmsModalForm>;
  getTemplates: () => T;
  variables: IVariable[];
}

export const SmsModalForm = <T extends TGetCommunicationTemplates>({
  control,
  candidates,
  setValue,
  getValues,
  getTemplates,
  variables,
}: ISmsModalFormProps<T>) => {
  const templates = getTemplates();

  return (
    <>
      <MenuTemplateSms control={control} setValue={setValue} templates={templates.filter(filterSmsTemplateType)} />
      <Recipients
        control={control as unknown as Control<IRecipientsForm>}
        candidates={candidates}
        label="Destinataires *"
        getOptionDisabled={(option) => !isSmsEligibleCandidate(option)}
        sx={{ maxWidth: 424 }}
      />
      <SmsContent control={control} getValues={getValues} variables={variables} />
    </>
  );
};
